import layout from '@/layout/index'
import businessCenter2 from '@/module/dataCenter/page/businessManager'
import customerFlow from '@/module/dataCenter/page/customerManager'
import alarmRecordStatistic from '@/module/dataCenter/page/alarmManager'
import reportManage from '@/module/dataCenter/page/reportManage'
import dataExport from '@/module/dataCenter/page/dataExport'
import manage from '@/module/dataCenter/page/baobiao/manage'
import stationPercentageManager from '@/module/dataCenter/page/stationPercentageManager'
// 导出配置的路由器
export default [{
  // 默认进入此页面
  path: '/dataCenter',
  component: layout,
  redirect: 'dataCenter/businessCenter2',
  meta: {
    title: '数据中心',
    icon: 'icon-icon-bar-chart-o',
    perms: ['bee:dataCenter']
  },
  children: [
    {
      path: 'businessCenter2',
      component: businessCenter2,
      meta: {
        icon: 'icon-jingying',
        title: '经营中心',
        perms:['bee:order:businessCenter']
      }
    },
    {
      path: 'customerFlow',
      component: customerFlow,
      meta: {
        icon: 'icon-keliuxinxi',
        title: '客流分析',
        perms:['bee:member:customerFlow']
      }
    },
    {
      path: 'alarmRecordStatistic',
      component: alarmRecordStatistic,
      meta: {
        icon: 'icon-fault',
        title: '故障分析',
        perms:['bee:ops:statistic']
      }
    },
    {
      path: 'stationPercentage',
      component: stationPercentageManager,
      meta: {
        icon: 'icon-chart',
        title: '百分比管理',
        perms:['bee:ops:percentage']
      }
    },
    {
      path: 'manage',
      component: manage,
      meta: {icon: 'icon-chart', title: '报表管理',perms:['bee:order:report']}
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/dataCenter/router/index.js